import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Stethoscope, Factory, GraduationCap } from "lucide-react";
import { api } from "@/lib/api";

const KINDS = {
  aso: { label: "ASO", icon: Stethoscope, to: "/medicina", cls: "bg-sky-50 text-sky-700" },
  portal: { label: "Portal", icon: Factory, to: "/portais", cls: "bg-violet-50 text-violet-700" },
  training: { label: "Treinamento", icon: GraduationCap, to: "/treinamentos", cls: "bg-emerald-50 text-emerald-700" },
};

const dayCls = (d) => (d <= 7 ? "bg-rose-100 text-rose-700" : d <= 30 ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600");

export function ExpirationsPanel() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const nav = useNavigate();
  useEffect(() => { api.get("/dashboard/expirations").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  const count = (k) => items.filter((i) => i.kind === k).length;
  const shown = filter === "all" ? items : items.filter((i) => i.kind === filter);

  return (
    <div className="mb-6 rounded-xl border border-[#E2E8F0] bg-white p-5 shadow-sm" data-testid="expirations-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 font-semibold text-[#0B2545]"><CalendarClock className="h-5 w-5 text-amber-500" /> Vencimentos nos próximos 60 dias</p>
        <div className="flex flex-wrap gap-1.5">
          {[["all", `Todos (${items.length})`], ...Object.entries(KINDS).map(([k, v]) => [k, `${v.label} (${count(k)})`])].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setFilter(k)} data-testid={`expirations-filter-${k}`}
              className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${filter === k ? "bg-[#0B2545] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="mt-4 max-h-80 divide-y divide-slate-100 overflow-y-auto" data-testid="expirations-list">
        {!shown.length && <p className="py-6 text-center text-sm text-slate-400" data-testid="expirations-empty">Nada vencendo nos próximos 60 dias.</p>}
        {shown.map((i) => {
          const K = KINDS[i.kind];
          return (
            <button key={`${i.kind}-${i.id}`} type="button" onClick={() => nav(K.to)} data-testid={`expiration-${i.kind}-${i.id}`}
              className="flex w-full items-center gap-3 py-2.5 text-left transition-colors hover:bg-slate-50">
              <span className={`inline-flex shrink-0 items-center gap-1 rounded-md px-2 py-1 text-[11px] font-semibold ${K.cls}`}><K.icon className="h-3.5 w-3.5" /> {K.label}</span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-slate-800">{i.employee_name || "—"}</p>
                <p className="truncate text-xs text-slate-500">{i.item}</p>
              </div>
              <span className="hidden text-xs text-slate-500 sm:block">{i.expires_at.split("-").reverse().join("/")}</span>
              <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-bold ${dayCls(i.days)}`}>{i.days === 0 ? "Hoje" : `${i.days}d`}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
